import Icon, { IconType } from "@edaz/edazkit/Icon";
import classnames from "classnames";
import React from "react";
import { Alert } from "react-bootstrap";
import type { Variant } from "react-bootstrap/types";

export interface AlertWithIconProps {
  children: React.ReactNode;
  variant?: Variant;
  icon?: IconType;
  className?: string;
}

export default function alertWithIcon(props: AlertWithIconProps) {
  return (
    <Alert
      variant={props.variant ?? "info"}
      className={classnames(props.className, "d-flex border-none align-items-center text-shadow-none py-3", {
        "text-muted": props.variant === "light",
      })}>
      <div className="row">
        <div className="pr-0 col col-auto">
          <Icon icon={props.icon ?? IconType.Info} width={24} height={24} className="d-sm-block d-none" />
        </div>
        <div className="d-flex align-items-center col">{props.children}</div>
      </div>
    </Alert>
  );
}
